import { CfgToastNotificationType } from '@cfgtech/ui';

type AsyncOperationHandlerNotifyOption = {
  successTitleKey?: string,
  errorTitleKey?: string
}

export function useAsyncOperationHandler() {
  const { t } = useI18n();

  async function handleAsyncOperation(
    operation: () => Promise<void>,
    { successTitleKey, errorTitleKey }: AsyncOperationHandlerNotifyOption,
    catchOperationError?: (err?: unknown) => Promise<void> | void,
    finallyOperation?: (err?: unknown) => Promise<void> | void,
  ): Promise<void> {
    if (!notify) {
      throw new Error('Notify function not provided');
    }

    try {
      await operation();
      if (successTitleKey) {
        notify({
          type: CfgToastNotificationType.Success,
          title: t(successTitleKey),
          text: '',
        });
      }
    } catch (err) {
      if (errorTitleKey) {
        notify({
          type: CfgToastNotificationType.Error,
          title: t(errorTitleKey),
          text: '',
        });
      }
      if (catchOperationError) {
        await catchOperationError(err);
      }
    } finally {
      if (finallyOperation) {
        await finallyOperation();
      }
    }
  }

  return { handleAsyncOperation };
}
